import endpoints from '../endpoints/tms-be';

function getSellerId(spotId) {
  return endpoints.fetchSellerId.execute(undefined, { spotId });
}

export default {
  getSellerId
};
